<template>
  <div class="flex-column h-100">
    <div class="custom-tab-body-cont h-100">
      <update-item v-for="(entity) in entities" :key="entity.ID" :entity="entity" v-on:toggleGroup="toggleGroup" v-on:toggleSite="toggleSite"></update-item>
      <empty-placeholder v-if="entities.length===0" v-bind="placeholderProps"></empty-placeholder>
    </div>
    <div class="custom-tab-body-footer">
      <b-row>
        <b-col>
          <b-form-checkbox size="xl" class="select-all darkbg" :checked="selectAll" v-on:change="select($event)">Select All</b-form-checkbox>
        </b-col>
        <b-col class="text-right">
          <label class="selected-label">{{selectedUpdatesCount}} selected</label>
          <span>
            <b-button v-if="!viewIgnore" variant="outline-secondary" @click="ignore()" :disabled="$v.selectedUpdates.$invalid">
              Ignore
              <spinner size="small" class="greybg" v-if="buttonLoaders.ignore"></spinner>
            </b-button>
            <b-button v-else variant="outline-secondary" @click="unIgnore()" :disabled="$v.selectedUpdates.$invalid">
              Un-Ignore
              <spinner size="small" class="greybg" v-if="buttonLoaders.unIgnore"></spinner>
            </b-button>
            <b-button variant="primary" class="ml-6" @click="update" :disabled="$v.selectedUpdates.$invalid">
              Update
              <spinner size="small" v-if="buttonLoaders.update"></spinner>
            </b-button>
          </span>
        </b-col>
      </b-row>
    </div>
  </div>
</template>

<script>
import updateItem from './updateItem';
import { validationMixin } from 'vuelidate';
import { required, minLength } from 'vuelidate/lib/validators';
import EmptyPlaceholder from '../Common/EmptyPlaceholder';

export default {
  name: 'entityupdater',
  props: ['entities', 'type', 'buttonLoaders', 'viewIgnore'],
  components: {
    updateItem,
    EmptyPlaceholder
  },
  data() {
    return {
      selectAll: false,
      currentTabIndex: 0,
      showUpdatePopup: false,
      placeholderProps: {
        text: () => {
          return `Looks like there are no ${this.type} updates.`;
        },
        type: 'positive'
      }
    };
  },
  mixins: [validationMixin],
  validations: {
    selectedUpdates: {
      required
    }
  },
  computed: {
    selectedUpdates(updates) {
      let sites = [];
      _.each(this.entities, update => {
        let selectedSites = _.filter(update.sites, { selected: true });
        sites = _.concat(sites, selectedSites);
      });
      return sites;
    },
    selectedUpdatesCount() {
      return this.selectedUpdates.length;
    }
  },
  methods: {
    select(selectedValue) {
      this.$emit('selectAll', {
        type: this.type,
        value: selectedValue
      });
    },
    getSelectedUpdates(updates) {
      let sites = [];
      _.each(updates, update => {
        let selectedSites = _.filter(update.sites, { selected: true });
        sites = _.concat(sites, selectedSites);
      });
      return sites;
    },
    toggleGroup({ group, value }) {
      this.$store.commit({
        type: 'SELECT_GROUP_UPDATES',
        sites: group.sites,
        value: value
      });
      group.selected = value;
    },
    toggleSite({ group, site, isSelected }) {
      this.$store.commit({
        type: 'SELECT_SITE_UPDATE',
        site: site,
        value: isSelected
      });
    },
    update() {
      this.$emit('update', {
        value: this.getSelectedUpdates(this.entities)
      });
    },
    ignore() {
      this.$emit('ignore', {
        value: this.getSelectedUpdates(this.entities)
      });
    },
    unIgnore() {
      this.$emit('unIgnore', {
        value: this.getSelectedUpdates(this.entities)
      });
    }
  }
};
</script>

<style>
</style>



// WEBPACK FOOTER //
// src/components/Manage/EntityUpdater.vue